import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing16 } from 'approot/shared/styles/spacing.style';
import { grey4 } from 'approot/shared/styles/colours.style';
import { imageTransition } from 'approot/shared/images/images.style';
import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/secondary-button.style';

export const PresentContent = styled.div`
  padding: ${rem(spacing16)};
`;

export const PresentActivities = styled(PresentContent)`
  border-bottom: 1px solid ${grey4};
`;

export const PresentClose = styled(SecondaryButtonIcon)`
  position: absolute;
  top: ${rem(spacing16)};
  left: ${rem(spacing16)};
`;

type PresentMenuImageProps = {
  $imageHasLoaded?: boolean;
  $imageUrl?: string;
};
export const PresentMenuImage = styled.div.attrs<PresentMenuImageProps>(
  ({ $imageUrl }) => ({
    style: {
      backgroundImage: $imageUrl ? `url(${$imageUrl})` : '',
    },
  })
)<PresentMenuImageProps>`
  opacity: ${({ $imageHasLoaded }) => ($imageHasLoaded ? '1' : '0')};
  ${imageTransition}
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: ${rem(200)};
`;
